<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="dialog" width="400px">
      <v-card width="400px">
        <v-layout wrap pa-5>
          <v-flex xs12 text-center pb-5 style="font-family: nunitosansbold">
            Are you sure you want to delete this Notice?
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-end text-right>
              <v-flex align-self-center xs6 sm2
                ><v-btn
                  text
                  color="blue darken-1"
                  @click="remove(noticeData._id)"
                >
                  yes</v-btn
                ></v-flex
              >
              <v-flex align-self-center xs6 sm2
                ><v-btn text color="blue darken-1" @click="dialog = false">
                  No</v-btn
                ></v-flex
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex xs6 sm4 md1 lg1 pl-md-3>
        <v-img width="30px" src="./../../assets/images/notice.svg"></v-img>
      </v-flex>
      <v-flex xs12 md7 lg8>
        <span style="font-family: nunitosansbold; font-size: 18px"
          >Noticeboard</span
        >
      </v-flex>
      <v-flex xs3 md3>
        <router-link style="text-decoration: none" :to="{ path: '/noticeadd' }">
          <v-btn
            width="275px"
            outlined
            style="text-transform: none; font-size: 10px"
            color="#747474"
            >Create new Notice
          </v-btn>
        </router-link>
      </v-flex>
      <v-flex xs12 pt-5 pb-12>
        <v-layout wrap py-3>
          <v-flex xs12>
            <v-card>
              <v-img
                :style="
                  $vuetify.breakpoint.name == 'lg'
                    ? 'height:600 px'
                    : (style = 'width: 100%')
                "
                :src="mediaURL + noticeData.image"
              >
                <v-layout pa-8 wrap fill-height>
                  <v-flex>
                    <v-icon large color="white"
                      >mdi-image-outline</v-icon
                    ></v-flex
                  >
                  <v-flex xs12 align-self-end pb-12>
                    <v-layout wrap>
                      <v-flex md10 class="hidden-sm-and-down">
                        <span
                          style="
                            font-family: nunitosansextrabold;
                            font-size: 40px;
                            color: white;
                          "
                        >
                          {{ noticeData.title }}</span
                        >
                      </v-flex>
                      <v-flex md2 text-right align-self-end>
                        <span
                          ><v-icon color="white">mdi-attachment</v-icon></span
                        ><span v-if="noticeData.docs" style="color: white">{{
                          noticeData.docs.length
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout wrap pt-5>
          <v-flex pl-3>
            <v-card elevation="0" min-height="500">
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                  lg7
                  style="
                    font-family: nunitosanssemibold;
                    font-size: 25px;
                    color: #000000;
                  "
                >
                  {{ noticeData.title }}
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 md10 lg1 align-self-end>
                  <v-btn elevation="0" outlined color="grey" @click="edit">
                    <span> Edit</span>
                    <span><v-icon> mdi-pencil-box-outline </v-icon></span>
                  </v-btn>
                </v-flex>
                <v-flex align-self-end xs1 md1 lg1 text-right>
                  <v-icon large @click="dialog = true"> mdi-delete</v-icon>
                </v-flex>
              </v-layout>
              <v-layout wrap pt-5>
                <v-flex xs10>
                  <span style="color: #777676; font-family: nunitosansregular">
                    {{ noticeData.description }}
                  </span>
                </v-flex>
                <v-flex xs12 py-2 style="font-family: nunitosansregular">
                  {{ noticeData.author }}
                </v-flex>
                <v-flex xs10>
                  <v-layout wrap pb-3>
                    <v-flex
                      xs12
                      md2
                      style="color: #777676; font-family: nunitosansregular"
                    >
                      {{ noticeData.designation }}
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex
                      xs12
                      md3
                      style="
                        color: #777676;
                        font-family: nunitosansregular;
                        font-size: 12px;
                      "
                    >
                      {{ DateFormatted(noticeData.noticeDate) }}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs10>
                  <v-flex xs10 v-if="noticeData.docs">
                    <!-- <a v-for="(item,i ) in sg " :key="i"
                      style="text-decoration: none"
                      :href="mediaURL + item"
                      download="download"
                      target="_blank"
                    > -->
                    <v-btn
                      v-if="noticeData.docs.length > 0"
                      outlined
                      color="grey"
                      :style="
                        $vuetify.breakpoint.name == 'lg'
                          ? 'width: 400px'
                          : (style = 'width: 400')
                      "
                      @click="downloadAll(sg)"
                    >
                      <v-layout wrap justify-center>
                        <v-flex>
                          <span
                            style="
                              color: black;
                              text-transform: none;
                              font-family: nunitosanssemibold;
                            "
                          >
                            Download Attachments
                          </span>
                          <span>({{ sg.length }})</span>
                        </v-flex>
                        <v-flex text-right>
                          <v-icon size="20px">mdi-arrow-collapse-down</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      noticeData: [],
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: "",
      sg: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    downloadAll(urls) {
      console.log(urls);
      var link = document.createElement("a");

      link.style.display = "none";

      document.body.appendChild(link);
      for (var i = 0; i < urls.length; i++) {
        link.setAttribute("download", urls[i]);
        link.setAttribute("href", this.mediaURL + urls[i]);
        link.setAttribute("target", "_blank");
        link.click();
      }
      document.body.removeChild(link);
    },

    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y ,hh:mm A") : "";
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.key,
        },
      }).then((response) => {
        if (response.data.status) {
          this.noticeData = response.data.data;
          for (let i = 0; i < response.data.data.docs.length; i++) {
            this.sg.push(response.data.data.docs[i]);
          }
          this.appLoading = false;
        } else {
          console.log("failed");
        }
      });
    },
    edit() {
      this.$router.push({
        path: "/noticeEdit",
        query: {
          key: this.noticeData._id,
        },
      });
    },
    remove(item) {
      axios({
        method: "post",
        url: "/notice/remove",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      }).then((response) => {
        if (response.data.status) {
          this.showsnackbar = true;
          this.msg = "Successfully removed";
          this.$router.push({ path: "/noticeboard2" });
        } else {
          this.showsnackbar = true;
          this.msg = " Failed";
        }
      });
    },
  },
};
</script>